import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const RequireInstructor = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen grid place-items-center text-zinc-500">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "instructor") return <Navigate to="/dashboard" replace />;
  return children;
};

export default RequireInstructor;
